import { render, staticRenderFns } from "./LangRadio.vue?vue&type=template&id=007642d5"
import script from "./LangRadio.vue?vue&type=script&lang=js"
export * from "./LangRadio.vue?vue&type=script&lang=js"
import style0 from "./LangRadio.vue?vue&type=style&index=0&id=007642d5&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports